import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Stack,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

type BundleAbsorbChecksModalProps = {
  isOpen: boolean;
  bundleTitle: string;
  checkNames: string[];
  onCancel: () => void;
  onConfirm: () => void;
};

export function BundleAbsorbChecksModal({
  isOpen,
  bundleTitle,
  checkNames,
  onCancel,
  onConfirm,
}: BundleAbsorbChecksModalProps) {
  const { t } = useTranslation();
  const count = checkNames.length;
  const removeDuplicateLabel = t("Remove duplicate check", { count });

  return (
    <Modal isOpen={isOpen} testID="bundle-absorb-checks-modal">
      <Dialog>
        <DialogHeader onClose={onCancel}>{removeDuplicateLabel}</DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="global/body-primary">
              {t(
                "{{bundleName}} bundle already includes the following check. We'll remove the duplicate check to avoid redundant configuration.",
                { bundleName: bundleTitle, count }
              )}
            </Text>
            <ol className={styles.checkList}>
              {checkNames.map((checkName) => (
                <li key={checkName}>
                  <Text style="global/body-primary">{checkName}</Text>
                </li>
              ))}
            </ol>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <BasicButton
            size="medium"
            onPress={onCancel}
            testID="bundle-absorb-cancel-button"
          >
            <Trans>Cancel</Trans>
          </BasicButton>
          <PrimaryButton
            type="submit"
            size="medium"
            onPress={onConfirm}
            testID="bundle-absorb-confirm-button"
          >
            {removeDuplicateLabel}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}

const styles = {
  checkList: css({
    margin: 0,
    paddingLeft: "var(--space-5)",
    "& > li + li": {
      marginTop: "var(--space-1)",
    },
  }),
};
